const UAH_SYMBOL = '₴';

/**
 * Insert space thousand separators into an already-formatted numeric string,
 * e.g. `12345.67` -> `12 345.67`. Only the integer part is grouped.
 */
export const groupThousands = (formatted: string): string =>
  formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

/**
 * Format a numeric amount as UAH with 2 decimal places, e.g. `11.50 ₴`.
 * Uses `toFixed` (not Intl) to match the rest of the dashboard and keep
 * the output stable regardless of the browser locale.
 */
export const formatUAH = (amount: number, fractionDigits = 2): string =>
  `${amount.toFixed(fractionDigits)} ${UAH_SYMBOL}`;

/**
 * Grouped variant of {@link formatUAH} with space thousand separators,
 * e.g. `12 345.67 ₴`.
 */
export const formatUAHGrouped = (amount: number, fractionDigits = 2): string =>
  `${groupThousands(amount.toFixed(fractionDigits))} ${UAH_SYMBOL}`;

export { UAH_SYMBOL };
